import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-premiere-event-agenda',
  templateUrl: './mobile-premiere-event-agenda.component.html',
  styleUrls: ['./mobile-premiere-event-agenda.component.css']
})
export class MobilePremiereEventAgendaComponent implements OnInit {
  @Input('mobilePremiereDetails') mobilePremiereDetails:any;
  @Input('eventid') eventid: any;   //for symposium
  @Input('id') eventId: any;        //for spotlight
  constructor() { }

  ngOnInit(): void {
  }

 

}
